module.exports = __webpack_public_path__ + "static/Icons_homeloans_active_small-7482a58f510f730d9f5448453427104d.png";